(function () {
  if (window.__contentGridImageTopInitialized) return;
  window.__contentGridImageTopInitialized = true;

  var selector = '.content-grid__block[data-text-position="image-top"]';
  var rafId = null;

  function updateBlock(block) {
    if (!block) return;

    var imageBlock = block.querySelector('[data-content-grid-image-wrapper]');
    if (!imageBlock) return;

    var blockRect = block.getBoundingClientRect();
    var imageRect = imageBlock.getBoundingClientRect();
    var offsetTop = imageRect.top - blockRect.top;

    block.style.setProperty('--image-top-offset', offsetTop + 'px');
  }

  function updateAll(context) {
    var root = context || document;
    root.querySelectorAll(selector).forEach(updateBlock);
  }

  function scheduleUpdate(context) {
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(function () {
      updateAll(context);
      rafId = null;
    });
  }

  function init(context) {
    updateAll(context);

    (context || document).querySelectorAll(selector + ' img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', function () {
          scheduleUpdate(document);
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('load', function () {
    scheduleUpdate(document);
  });

  window.addEventListener('resize', function () {
    scheduleUpdate(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    scheduleUpdate(event.target.closest('.shopify-section') || document);
  });
})();